import { edgeTypeMatrix } from '@iotv/datamodel';
import { Cardinality, getCardinality, getZombieInstanceFromPrimaryKey } from '@iotv/iotv-v3-types';
/**
 * Uses the {@link edgeTypeMatrix | `edgeTypeMatrix`} to validate connections
 * - Assesses whether an edge can be made via types
 * - Assesses whether an edge is valid via cardinality
 *
 * The provided {@link NodeEdgeMapper | `NodeEdgeMapper`} should contain the {@link ValidBusinessObject | `ValidBusinessObject`s} and their edges
 */
export const useIsValidConnection = ({ nem }) => {
    const isValidConnection = (edge) => {
        const etm = edgeTypeMatrix;
        const parentType = edge.source.split(':')[0];
        const childType = edge.target.split(':')[0];
        if (!(parentType in etm))
            return false;
        const childTypes = etm[parentType];
        if (!childTypes)
            return false;
        if (!(childType in childTypes))
            return false;
        const childEdgeDefinitions = Object.values(childTypes[childType] ?? {});
        if (childEdgeDefinitions.length === 0)
            return false;
        // TODO: [CRA] assumes only one edge type between two VOBs
        const edgeDefinition = childEdgeDefinitions[0];
        // if cardinality is not set, assume we're good to go and bail
        if (!('cardinality' in edgeDefinition))
            return true;
        const parentCardinality = getCardinality(edgeDefinition.cardinality.in);
        const childCardinality = getCardinality(edgeDefinition.cardinality.out);
        if (parentCardinality === Cardinality.NONE)
            return false;
        if (childCardinality === Cardinality.NONE)
            return false;
        if (parentCardinality === Cardinality.MANY)
            return true;
        if (childCardinality === Cardinality.MANY)
            return true;
        const parent = nem.getItem(getZombieInstanceFromPrimaryKey(edge.source));
        const child = nem.getItem(getZombieInstanceFromPrimaryKey(edge.target));
        if (!parent || !child)
            return false;
        const parentEdges = nem.getChildEdges(parent);
        const childEdges = nem.getParentEdges(child);
        if (parentCardinality === Cardinality.ONE)
            return parentEdges.length < 1;
        if (childCardinality === Cardinality.ONE)
            return childEdges.length < 1;
        return true;
    };
    return { isValidConnection };
};
